<template>
  <div id="sovdetailed">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="datepickerwrap card " style="flex-direction: row">
      <div class="leftcontent wrapitem">
        <div class="datebox">
          <datepicker :disabled="date.disabled.startRange" placeholder="From" @input="changeCustomDate"
            v-model="date.startDate" />
        </div>
        <div class="datebox">
          <datepicker :disabled="date.disabled.endRange" placeholder="From" @input="changeCustomDate"
            v-model="date.endDate" />
        </div>
        <div class="datebox customSelect">
          <select v-model="selected_website" class="form-control text-uppercase">
            <option value="https://www.amazon.in">Amazon</option>
            <option value="https://www.amazon.in/gp/bestsellers">Amazon Bestsellers</option>
            <option value="https://www.flipkart.com">Flipkart</option>
          </select>
        </div>
        <div class="datebox">
          <select v-model="device" @change="refresh" class="form-control text-uppercase">
            <option value="laptop">Laptop PC</option>
            <option v-if="selected_website != 'https://www.amazon.in/gp/bestsellers'" value="gaming_laptop">Gaming
              Laptop</option>
            <option v-if="selected_website != 'https://www.amazon.in/gp/bestsellers'" value="non_gaming_laptop">Non
              Gaming Laptop</option>
            <option v-if="selected_website != 'https://www.amazon.in/gp/bestsellers'" value="processor">Processor
            </option>
            <!-- <option value="desktop">Desktop</option> -->
          </select>
        </div>
        <div class="datebox">
          <select v-model="selectedCatSearch" @change="refresh" class="form-control text-uppercase">
            <option v-for="d in catSearch" :value="d" :key='"cat_" + d'>{{ d.toUpperCase() }}</option>
          </select>
        </div>
        <div class="datebox">
          <button @click="refresh" class="btn primarycolor" type="button">
            <span>Submit</span>
          </button>
        </div>
      </div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float:right">
          <button @click="backToSov" style="width: max-content; float: right" class="navigationButton" type="button">
            <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon" />
            <span> Back</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid ">
      <div class="">
        <div class="card p-2 ">
          <div class="d-flex justify-content-end mb-3">
            <div class="checkbox-btn mr-3">
              <input type="checkbox" @change="showHeroChange" v-model="isHero" /> <span>Hero SKUs</span>
            </div>
            <div class="legending">
              <i class="fa fa-square" style="
              color: var(--primary_client-20) !important;
              border-radius: 2px;
              margin-right: 2px;
            "></i>          
            <span>AMD</span>
            </div>
            <div class="legending">
              <i class="fa fa-square" style="
              color: var(--primary_competitor-10) !important;
              border-radius: 2px;
              margin-right: 2px;
            "></i>
              <span>Intel</span>
            </div>
            <div class="legending">
              <i class="fa fa-square" style="
              color: var(--pink-20) !important;
              border-radius: 2px;
              margin-right: 2px;
            "></i>
              <span>Qualcomm Snapdragon</span>
            </div>
            <div class="legending">
              <i class="fa fa-square" style="
              color: var(--olive-20) !important;
              border-radius: 2px;
              margin-right: 2px;
            "></i>
              <span>N/A</span>
            </div>
            <div class="legending">
              <i class="fa fa-square" style="
              color: var(--accent_color-20) !important;
              border-radius: 2px;
              margin-right: 2px;
            "></i>
              <span>Mediatek</span>
            </div>
          </div>
          <table id="myTable2" class="table">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label }} </th>
              </tr>
            </tfoot>
            <tbody class="tbody-normal">
              <tr v-for="(r, i) in rows_details" :key="i" :class="{
      'markitamd': r['processor'] == 'amd',
      'markitintel': r['processor'] == 'intel', 'markitsnap': r['processor'] == 'qualcomm snapdragon', 'markitna': r['processor'] == 'N/A',
      'markittek': r['processor'] == 'mediatek'
    }">
                <td v-for="d in columns_details" :key="d.field">
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{ r[d.field] }}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span v-if="d.field == 'processor' && r['processor'] == 'amd'">
                        <a @click="openAuditModal(r)" style="color:#20a8d8;cursor:pointer;text-transform:uppercase"
                          title="Audit"> {{ r[d.field] }}</a>
                      </span>
                      <span v-else> {{ r[d.field] }}</span>
                    </span>
                    <span v-else>-</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal size="lg" title="Audit" v-model="showAuditModal">
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important">
              {{ d.label }}
              <span v-if="d.field == 'compliance_score'">
                <b-btn class="hint" v-b-tooltip.hover
                  title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn>
              </span>
              <span v-if="d.field == 'position_score'">
                <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn>
              </span>
              <span v-if="d.field == 'sku_score'">
                <b-btn class="hint" v-b-tooltip.hover
                  title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn>
              </span>
              <span v-if="d.field == 'rating_score'">
                <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn>
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important">
              {{ r[d.field] }}
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important">
              {{ d.label }}
              <span v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn>
              </span>
              <span v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn>
              </span>
              <span v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn>
              </span>
              <span v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn>
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important">
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important">
              {{ d.label }}
              <span v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn>
              </span>
              <span v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn>
              </span>
              <span v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn>
              </span>
              <span v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn>
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important">
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'sovdetailed',
  components: { Datepicker },
  data: function () {
    return {
      selected_website: 'https://www.amazon.in',
      device: 'laptop',
      date: {
        startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        disabled: {
          'startRange': {
            from: '',
            to: ''
          },
          'endRange': {
            from: '',
            to: ''
          }
        }
      },
      columns_details: [
        { label: 'Rank', field: 'order' },
        { label: 'Page', field: 'page' },
        { label: 'Brand', field: 'brand' },
        { label: 'Name', field: 'product_name', sortable: false },
        { label: 'Processor', field: 'processor', sortable: false },
        { label: 'Processor Type', field: 'processor_type', sortable: false },
        { label: 'Processor Model', field: 'processor_model', sortable: false },
        { label: 'GPU', field: 'gpu_type', sortable: false },
        { label: 'Price', field: 'price', sortable: false },
        { label: 'Offer', field: 'offer', sortable: false },
        { label: 'Reviews', field: 'reviews' },
        { label: 'Ratings', field: 'ratings' }
      ],
      rows: [],
      rows_details: [],
      page: 1,
      showAuditModal: false,
      columnsAudit: [
        { label: 'SKU', field: 'sku', sortable: false },
        { label: 'Compliance Score', field: 'compliance_score', sortable: false },
        { label: 'Position Score', field: 'position_score', sortable: false },
        { label: 'Rating Score', field: 'rating_score', sortable: false },
        { label: 'SKU Score', field: 'sku_score', sortable: false },
      ],
      columns_category: [
        { label: 'Category Position', field: 'category_position', sortable: false },
        { label: 'Category page position (1-3)', field: 'category_13_position', sortable: false },
        { label: 'Search Position', field: 'search_position', sortable: false },
        { label: 'Search (1-3) Position', field: 'search_13_position', sortable: false }
      ],
      columns_compliance: [
        { label: 'Product Logo', field: 'logo', sortable: false },
        { label: 'OEM Images', field: 'image_count', sortable: false },
        { label: 'Nomenclature', field: 'nomenclature', sortable: false },
        { label: 'Message', field: 'message', sortable: false }
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      deviceMapper: {
        'laptop': 'PC',
        'desktop': 'Desktop'
      },
      catSearch: ['category', 'search'],
      selectedCatSearch: 'category'
    }
  },
  mounted() {
    this.processDisablingDates()
    if (localStorage.selected_category) {
      this.device = localStorage.selected_category
    }
    if (this.date.endDate != this.date.startDate) {
      this.columns_details.splice(0, 2)
    }
    this.website_details()
  },
  methods: {
    processDisablingDates() {
      this.date.disabled = {
        'startRange': {
          from: moment(this.date.endDate).toDate(),
          to: ''
        },
        'endRange': {
          from: moment().subtract(1, 'day').toDate(),
          to: moment(this.date.startDate).toDate()
        }
      }
    },
    backToSov() {
      window.location = '#/sov-summary-amd'

    },
    showHeroChange() {
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (self.isHero) {
          if (dataset.is_hero) {
            this.rows_details.push(dataset)
          }
        }
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function () {
        self.initDt2()
      })
    },

    openAuditModal(r) {
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },

    format(v) {
      return this.$options.filters.format(v)
    },
    refresh() {
      $('#myTable2').DataTable().destroy();
      this.processDisablingDates()
      localStorage.selected_website = this.selected_website
      localStorage.selected_category = this.device
      this.columns_details = [
        { label: 'Rank', field: 'order' },
        { label: 'Page', field: 'page' },
        { label: 'Brand', field: 'brand' },
        { label: 'Name', field: 'product_name', sortable: false },
        { label: 'Processor', field: 'processor', sortable: false },
        { label: 'Processor Type', field: 'processor_type', sortable: false },
        { label: 'Processor Model', field: 'processor_model', sortable: false },
        { label: 'GPU', field: 'gpu_type', sortable: false },
        { label: 'Price', field: 'price', sortable: false },
        { label: 'Offer', field: 'offer', sortable: false },
        { label: 'Reviews', field: 'reviews' },
        { label: 'Ratings', field: 'ratings' }]
      if (this.date.endDate != this.date.startDate) {
        this.columns_details.splice(0, 2)
      }
      this.website_details()
    },

    website_details() {
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      let payload = {
        "website": this.selected_website,
        "start_date": this.date.startDate,
        "end_date": this.date.endDate,
        "data_type": this.selectedCatSearch,
        "item_category": self.device
      }
      const url = "/api/amazon_india/india_show_detail"
      this.$http.post(url, payload).then(response => {
        console.log(response.body.data.data)
        for (let [idx, ds] of response.body.data.data.entries()) {
          if (ds.brand == 'hp') ds.brand = 'HP'
          if (ds.processor_type.indexOf('amd') != -1) ds.processor_type = ds.processor_type.replace('amd', 'AMD')
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function () {
          self.initDt2()
        })

      }, err => {
        self.loader = false
        console.log(err)
        console.log('err')
      });
    },

    changeCustomDate() {
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      if (this.date.endDate)
        this.date.endDate = moment(this.date.endDate).format('YYYY-MM-DD')
      this.processDisablingDates()
    },
    initDt2() {
      let self = this
      $('#myTable2').DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          pagingType: "full_numbers",

          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
        initComplete: function () {
          this.api().columns().every(function () {
            var column = this;
            var select = $('<select><option value="">All</option></select>')
              .appendTo($(column.footer()).empty())
              .on('change', function () {
                var val = $.fn.dataTable.util.escapeRegex(
                  $(this).val()
                );
                column
                  .search(val ? '^' + val + '$' : '', true, false)
                  .draw();
              });
            let arr = []
            let sortedArr = []
            column.data().unique().sort().each(function (d, j) {
              var myVal = $(d).text()
              arr.push(myVal)
            });

            sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, { numeric: true, ignorePunctuation: true }))
            for (let [idx, ds] of sortedArr.entries()) {
              select.append('<option value="' + ds + '">' + ds + '</option>')
            }
          });
        }
      });
      var searchIcon = require("../../../public/Icons_SVG/Search.svg");
      $("#myTable2_filter > label > input").attr(
        "placeholder",
        "Search"
      );
      $("#myTable2_filter > label").append(
        `<div class='search_icon'><img src='${searchIcon}' /></div>`
      );
      // $("#amdglobal-compliance-sov-detailTable_filter").prepend(`<div class='filter_icon'><img src='${funnel}' /></div>`);
      // $("#amdglobal-compliance-sov-detailTable_filter > div.filter_icon").click(() => this.filterAddAction())
      $("#myTable2_length > label > select").removeClass();
    }
  }
}

</script>


<style>
#myTable2_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#myTable2_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#myTable2_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#myTable2_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#myTable2_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#myTable2_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#myTable2 .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

div#myTable2_filter {
  display: flex;
  justify-content: end;
}

#myTable2_filter div.search_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#myTable2_filter div.search_icon img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#myTable2_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#myTable2_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

#myTable2_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#myTable2_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#myTable2_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#myTable2_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#myTable2_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#myTable2_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#myTable2_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#myTable2_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#myTable2 {
  border-radius: 20px 20px 0 0;
}

#myTable2 .thead-normal,
#myTable2 .thead-normal tr,
#myTable2 .thead-normal>tr>th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#myTable2 .thead-normal>tr>th:last-child {
  border-radius: 0 21px 0 0;
}

#myTable2 .thead-normal>tr>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#myTable2 .thead-normal>tr>th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#myTable2 .thead-normal>tr>th.sorting:after {
  /* top: -40%; */
  font-size: 15px;
  color: var(--base_color-80);
}

#myTable2 th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#myTable2 tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#myTable2 tfoot th:first-child {
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#myTable2 tbody td {
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;

  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#myTable2 tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#myTable2 .even td {
  /* background: #fff !important; */
}

#myTable2 .odd td {
  /* background: #fff !important; */
  /* filter: brightness(110%); */
}

/* #myTable2_wrapper .bottom{
  margin: -30px;
} */
#myTable2_wrapper>.row:last-child {
  margin-bottom: 15px;
}

#myTable2_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#myTable2_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#myTable2_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#myTable2_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}

#myTable2_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}
</style>


<style scoped>

.card{
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1.5rem !important;
}
.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}
.legending {
  display: flex;
  align-items: center;
  margin-right: 19px;
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
}

.checkbox-btn span {
  padding: 0 5px;
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  width: 15px;
  height: 15px;
  accent-color: #fff;
}
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important
}

.markitintel {
  background-color: #c7e0ff !important;
}

.markitsnap {
  background-color: #ffd0f5 !important
}

.markitna {
  background-color: #edf2fb !important
}

.markittek {
  background-color: #fff0ce !important
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #533a79;
  margin-bottom: 0;
  line-height: 31px;
}

.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}

.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}

#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px
}

.mycols:first-child {
  padding-right: 2px !important
}

.mycols:last-child {
  padding-left: 2px
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px
}
</style>
